import { render, staticRenderFns } from "./HeaderFluxo.vue?vue&type=template&id=2aeb29f3"
import script from "./HeaderFluxo.vue?vue&type=script&lang=ts"
export * from "./HeaderFluxo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports